import Aos from "aos";
import MobileNavigation from "@root/modules/MobileNavigation";
import LanguageSwitcher from "@root/modules/LanguageSwitcher";
import ScrollToTop from "@root/modules/ScrollToTop";
import MainNavigation from "@root/modules/MainNavigation";
import Footer from "@root/modules/Footer";
import CustomSelect from "@root/modules/CustomSelect";
import Header from "@root/modules/Header";
import ModalToggle from "@modules/ModalToggle";
import GalleryModal from "@modules/GalleryModal";
Aos.init();
window.aos = Aos; // Make AOS available globally
new CustomSelect();
new MainNavigation();
new LanguageSwitcher();
new MobileNavigation();
new ScrollToTop();
new Header();
new Footer();
new ModalToggle();
window.galleryModal = new GalleryModal();
